import { render, staticRenderFns } from "./NoteEdit.vue?vue&type=template&id=0d0470a5&"
import script from "./NoteEdit.vue?vue&type=script&lang=js&"
export * from "./NoteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports